import { useState } from 'react';
import { requestLoginCode } from './api';

const LOGIN_EMAIL_KEY = 'referralLoginEmail';

export default function LoginEmailPage() {
  const [email, setEmail] = useState('');
  const [err, setErr] = useState('');
  const [loading, setLoading] = useState(false);

  const valid = /^[^@\s]+@[^@\s]+\.[^@\s]+$/.test(email.trim());

  const submit = async () => {
    setErr('');
    if (!valid) { setErr('Enter a valid email'); return; }
    const clean = email.trim();
    setLoading(true);
    try {
      // Anti-enumeration: the API always returns 200, and we always advance to
      // the code screen — we never reveal whether this email is a referrer.
      await requestLoginCode(clean);
    } catch {
      // Even on an unexpected error we advance (the message is deliberately
      // neutral). The code screen offers a "Resend code" action to retry.
    } finally {
      try { sessionStorage.setItem(LOGIN_EMAIL_KEY, clean); } catch { /* ignore */ }
      setLoading(false);
      window.location.hash = '#/login/code';
    }
  };

  return (
    <div className="wrap">
      <div className="brand">VANTAGE · Referral Portal</div>
      <h1 className="title">Log in to your portal</h1>
      <p className="lead">Enter your email and we'll send you a 6-digit code to log in.</p>

      <div className="card">
        <h2>Email</h2>
        <div className="form-field">
          <label>Email<span className="req"> *</span></label>
          <input
            type="email"
            inputMode="email"
            value={email}
            onChange={(e) => { setEmail(e.target.value); setErr(''); }}
            onKeyDown={(e) => { if (e.key === 'Enter') submit(); }}
            placeholder="you@example.com"
          />
          {err && <div className="form-err">{err}</div>}
        </div>
      </div>

      <button className="primary-cta" onClick={submit} disabled={loading}>
        {loading ? 'Sending…' : 'Send me a code'}
      </button>

      <p className="lead" style={{ marginTop: 18, textAlign: 'center' }}>
        New here? <a href="#/signup">Become a referrer</a>
      </p>
    </div>
  );
}

export { LOGIN_EMAIL_KEY };
